module.exports = __webpack_public_path__ + "img/62400.c3017fb1.jpg";